import React, { Component } from 'react';

export default class MetricQuantitySlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

    }

    render() {
        let quantity = this.props.quantity;

        let oneOptionClass = quantity != 1 ? 'gc-quan-button' : 'gc-quan-button gc-button--active';
        let twoOptionClass = quantity != 2 ? 'gc-quan-button' : 'gc-quan-button gc-button--active';
        let threeOptionClass = quantity != 3 ? 'gc-quan-button' : 'gc-quan-button gc-button--active';
        let oneIconClass = quantity === 1 ?
            'gc-scope-icon quan gc-icon--active' : 'gc-scope-icon quan gc-scope-icon--left';
        let twoIconClass = quantity === 2 ?
            'gc-scope-icon quan gc-icon--active' :
            (quantity === 3 ? 'gc-scope-icon quan gc-scope-icon--left' : 'gc-scope-icon quan gc-scope-icon--right');
        let threeIconClass = quantity === 3 ?
            'gc-scope-icon quan gc-icon--active' : 'gc-scope-icon quan gc-scope-icon--right';


        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        let cardHeight = this.props.position === this.props.slideNumber ? 20 : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                <div className={oneIconClass}>1</div>
                <div className={twoIconClass}>2</div>
                <div className={threeIconClass}>3</div>
                <div className="gc-question scope">How many metrics are involved in this contest?</div>
                <div className={oneOptionClass} onClick={this.props.onSelect.bind(null, 1)}>One</div>
                <div className={twoOptionClass} onClick={this.props.onSelect.bind(null, 2)}>Two</div>
                <div className={threeOptionClass} onClick={this.props.onSelect.bind(null, 3)}>Three</div>
            </div>
        );
    }
}